import { Component, Inject, inject, OnInit } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { MsgService } from '../../../../Shared/Services/msg.service';

@Component({
  selector: 'app-password-success-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
  ],
  templateUrl: './password-success-dialog.component.html',
  styleUrls: ['./password-success-dialog.component.scss', '../../../../../../assets/theme/cutom/_av-dialog.scss'],
})
export class PasswordSuccessDialogComponent implements OnInit {
  private readonly _clipboard = inject(Clipboard);
  private readonly _msg = inject(MsgService);

  constructor(
    public dialogRef: MatDialogRef<PasswordSuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { title: string; password: string; }
  ) { }

  ngOnInit(): void {
    this.copyPassword();
  }

  copyPassword(): void {
    this._clipboard.copy(this.data.password);
    this._msg.showSnackBar('shared.general.messages.copied_to_clipboard');
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
